// digital ocean
// export const BASE_URL = "https://api-payweek.digibranders.com/"
// export const BASE_URL = "http://64.23.128.206/";
// AWS
// export const BASE_URL = 'http://3.109.135.228/';
// export const BASE_URL = 'http://127.0.0.1:8000/';
export const BASE_URL = "https://api-payweek-dev.digibranders.com/"


